<header class="header">
  <h3 class="header__title bold">Descargas</h3>
</header>
<ul class="download-items__list">
  <li *ngFor="let document of data.printableDocuments" class="download-items__item">
    <sc-download-item [item]="document"></sc-download-item>
  </li>
</ul>
<sc-info-box *ngIf="data.hasSubitems" class="info">Las descargas pertinentes a cada vehículo se pueden encontrar en el listado de incisos</sc-info-box>
